
export {} from '@clayui/alert';
import __x__ from '@clayui/alert';export default __x__;